const initialState = {
  drawerOpen: false,
  showHistory: false,

  discussions: [],
  discussionsLoading: false,

  currentDiscussionId: null,
  messages: [],
  messagesLoading: false,

  // Message assistant en cours de generation : son texte s'accumule ici plutot
  // que dans `messages`, pour ne pas recreer la liste a chaque token recu.
  streamingMessageId: null,
  streamingText: "",

  pendingImages: [],
  asking: false,
  error: null,
};

const iaReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ------------------------------- Tiroir ------------------------------- */
    case "IA_OPEN_DRAWER":
      return { ...state, drawerOpen: true };
    case "IA_CLOSE_DRAWER":
      return { ...state, drawerOpen: false };
    case "IA_TOGGLE_DRAWER":
      return { ...state, drawerOpen: !state.drawerOpen };
    case "IA_SHOW_HISTORY":
      return { ...state, showHistory: action.payload };

    /* ----------------------------- Discussions ---------------------------- */
    case "IA_DISCUSSIONS_LOADING":
      return { ...state, discussionsLoading: true };
    case "IA_DISCUSSIONS_SUCCESS":
      return { ...state, discussionsLoading: false, discussions: action.payload };
    case "IA_DISCUSSIONS_FAIL":
      return { ...state, discussionsLoading: false, error: action.payload };

    case "IA_MESSAGES_LOADING":
      return {
        ...state,
        messagesLoading: true,
        currentDiscussionId: action.payload,
        showHistory: false,
      };
    case "IA_MESSAGES_SUCCESS":
      return {
        ...state,
        messagesLoading: false,
        currentDiscussionId: action.payload.discussionId,
        messages: action.payload.messages,
        streamingMessageId: null,
        streamingText: "",
      };
    case "IA_MESSAGES_FAIL":
      return { ...state, messagesLoading: false, error: action.payload };

    case "IA_NEW_DISCUSSION":
      return {
        ...state,
        currentDiscussionId: null,
        messages: [],
        streamingMessageId: null,
        streamingText: "",
        pendingImages: [],
        showHistory: false,
        error: null,
      };

    case "IA_DISCUSSION_DELETED": {
      const discussions = state.discussions.filter((d) => d.id !== action.payload);
      const wasCurrent = state.currentDiscussionId === action.payload;
      return {
        ...state,
        discussions,
        currentDiscussionId: wasCurrent ? null : state.currentDiscussionId,
        messages: wasCurrent ? [] : state.messages,
        streamingMessageId: wasCurrent ? null : state.streamingMessageId,
        streamingText: wasCurrent ? "" : state.streamingText,
      };
    }

    /* -------------------------------- Images ------------------------------ */
    case "IA_IMAGE_UPLOADING":
      return {
        ...state,
        pendingImages: [
          ...state.pendingImages,
          { ...action.payload, id: null, uploading: true },
        ],
      };
    case "IA_IMAGE_UPLOADED":
      return {
        ...state,
        pendingImages: state.pendingImages.map((image) =>
          image.localId === action.payload.localId
            ? { ...image, id: action.payload.id, uploading: false }
            : image
        ),
      };
    case "IA_IMAGE_FAILED":
    case "IA_IMAGE_REMOVED": {
      const localId = action.payload?.localId || action.payload;
      const removed = state.pendingImages.find((i) => i.localId === localId);
      // L'URL d'apercu est un objet blob : sans revoke, chaque image ajoutee
      // puis retiree resterait en memoire jusqu'au rechargement de la page.
      if (removed?.preview) URL.revokeObjectURL(removed.preview);
      return {
        ...state,
        pendingImages: state.pendingImages.filter((i) => i.localId !== localId),
      };
    }

    /* ------------------------------- Question ----------------------------- */
    case "IA_ASK_LOADING":
      return { ...state, asking: true, error: null };

    case "IA_ASK_SUCCESS": {
      const { discussionId, userMessageId, messageId, question, images } = action.payload;
      const now = new Date().toISOString();

      return {
        ...state,
        asking: false,
        currentDiscussionId: discussionId,
        pendingImages: [],
        streamingMessageId: messageId,
        streamingText: "",
        messages: [
          ...state.messages,
          {
            id: userMessageId,
            role: "user",
            content: question,
            status: "done",
            createdAt: now,
            // `preview` est une URL blob locale : elle affiche l'image avant que
            // le fil ne soit rechargé depuis le serveur.
            images: images.map((image) => ({
              id: image.id,
              url: image.preview,
              name: image.name,
            })),
          },
          {
            id: messageId,
            role: "assistant",
            content: "",
            status: "streaming",
            createdAt: now,
          },
        ],
      };
    }

    case "IA_ASK_FAIL":
      return { ...state, asking: false, error: action.payload };

    /* ------------------------------ Streaming ----------------------------- */
    case "IA_TOKEN":
      if (action.payload.messageId !== state.streamingMessageId) return state;
      return { ...state, streamingText: state.streamingText + action.payload.delta };

    case "IA_DONE":
      return {
        ...state,
        streamingMessageId: null,
        streamingText: "",
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? {
                ...message,
                content: action.payload.content,
                costUsd: action.payload.costUsd,
                status: "done",
              }
            : message
        ),
      };

    case "IA_ERROR":
      return {
        ...state,
        streamingMessageId: null,
        streamingText: "",
        messages: state.messages.map((message) =>
          message.id === action.payload.messageId
            ? { ...message, status: "error", errorMessage: action.payload.message }
            : message
        ),
      };

    // Une deconnexion ne doit pas laisser la conversation d'un utilisateur
    // visible pour le suivant sur le meme poste.
    case "LOGOUT":
      return initialState;

    default:
      return state;
  }
};

export default iaReducer;
